// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2IQ9X{display:-ms-flexbox;display:flex;height:calc(100% - 45px)}._2hD64{background:#fff;border-radius:8px;-webkit-box-shadow:0 4px 10px rgba(50,66,121,.05);box-shadow:0 4px 10px rgba(50,66,121,.05);padding:3.2rem;width:680px;width:68rem}.UJsfW{width:100%}._77hu0{-webkit-box-shadow:none;box-shadow:none}.hdoT3{margin-bottom:2.4rem;padding-bottom:1.6rem;position:relative}.hdoT3:after{border-top:1px solid #e0e8f2;bottom:0;content:\"\";height:0;position:absolute;width:144px}html[dir=ltr] .hdoT3:after{left:0}html[dir=rtl] .hdoT3:after{right:0}._8dYlC{height:40px;height:4rem;width:40px;width:4rem}html[dir=ltr] ._8dYlC{margin-right:2.4rem}html[dir=rtl] ._8dYlC{margin-left:2.4rem}._3rubn{height:160px;height:16rem;width:160px;width:16rem}", ""]);
// Exports
exports.locals = {
	"wrapper": "_2IQ9X",
	"box": "_2hD64",
	"box--full-width": "UJsfW",
	"box--no-shadow": "_77hu0",
	"box__header": "hdoT3",
	"box__icon": "_8dYlC",
	"box__image": "_3rubn"
};
module.exports = exports;
